<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :module_name="page.name"/>
    <v-row>
      <v-col>
        <base-table ref="base_table" :page="page" @create="create" @edit="edit"/>
      </v-col>
    </v-row>
    <base-create-dialog modal_name="create_new_record" ref="create_new_record" :page="page" @refresh="reload"/>
  </v-container>
</template>

<script>
import BaseTable from "../../components/commonComponents/BaseTable";
import BaseBreadcrumb from "../../components/commonComponents/BaseBreadcrumb";
import BaseCreateDialog from "../../components/commonComponents/BaseCreateDialog";
import helpFunctions from "../../plugins/helpFunctions";

export default {
  components: {
    BaseCreateDialog,
    BaseTable,
    BaseBreadcrumb,
  },
  data() {
    return {
      page: helpFunctions.pages.projects,
    };
  },
  methods: {
    create() {
      this.$refs.create_new_record.load();
    },
    edit(item) {
      this.$router.push("/" + this.page.name + "/" + item.id);
    },
    reload() {
      this.$refs.base_table.run();
    },
  },
};
</script>
